import React, {useEffect} from 'react';

import {service as ContactService} from "../../../Services/ContactService";
import {service as RelationshipService} from "../../../Services/RelationshipService";
import {ContactNameTableColumn} from "./NameTableColumn";
import {TextTableColumn} from "../../Common/Tables/TextTableColumn";
import {StreamBankTable} from "../../Common/Table/StreamBankTable";

export const ContactsTable = React.forwardRef((props, ref) => {
    useEffect(() => {
        RelationshipService.PrimeCache();
    }, [])
    
    const getStakeholderRelationship = (contact) => {

        if (RelationshipService.cached) {

            let results = (contact.ProjectStakeholderRelationship ?? [])
                .map( projectStakeholderRelationship => RelationshipService.CachedValueById(projectStakeholderRelationship.relationshipId)?.result)
                .filter(x => x)
                .map( x => RelationshipService.GetTitle(x) );
            
            // unique values only
            return Array.from(new Set(results)).join(', ');

        } else {
            return "Loading...";
        }

    }

    const columnDefs = [
        {
            title: "Name",
            key: "name",
            sortable: true,
            logic: (x) => ContactService.GetTitle(x),
            renderer: ContactNameTableColumn
        },
        {
            title: "Relationship(s)",
            key: "relationship",
            sortable: true,
            logic: getStakeholderRelationship,
            renderer: TextTableColumn
        },
        {
            title: "Email",
            key: "email",
            sortable: true,
            logic: (x) => x.StakeholderAddresses?.Address?.email ?? "N/A",
            renderer: TextTableColumn
        },
        {
            title: "Phone",
            key: "phone",
            sortable: true,
            logic: (x) => x.StakeholderAddresses?.Address?.phone ?? "N/A",
            renderer: TextTableColumn
        }
    ];

    return <StreamBankTable
        columnDefs={columnDefs}
        itemNamePlural="contacts"
        getKeyForRow={x => x.stakeholderId}

        ref={ref}

        {...props}

    />;
});


